import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { getRolDisplayName } from "../utils/constants";
import "../styles/styles.css";

export default function Navbar({ toggleSidebar }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleSettings = () => {
    navigate("/dashboard/configuracion");
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar px-3 py-2" role="navigation" aria-label="main navigation" style={{ backgroundColor: '#2d2749', maxWidth: '1200px' }}>
      <div className="navbar-brand is-flex is-align-items-center">
        {/* Sidebar toggle button */}
        <button
          className="button is-gold is-small mr-3"
          onClick={toggleSidebar}
          title="Toggle Sidebar"
        >
          <span className="icon">
            <i className="fas fa-bars"></i>
          </span>
        </button>
        
        <span className="navbar-item has-text-white is-size-6 is-hidden-mobile">
          Bienvenido, {usuario?.nombres || "Usuario"} - {getRolDisplayName(usuario?.rol)}
        </span>
      </div>

      <div className={`navbar-menu ${isMenuOpen ? 'is-active' : ''}`}>
        <div className="navbar-start is-hidden-tablet">
          <div className="navbar-item has-text-white is-size-7">
            Bienvenido, {usuario?.nombres || "Usuario"} - {getRolDisplayName(usuario?.rol)}
          </div>
        </div>
        
        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons is-flex is-align-items-center is-flex-direction-column-mobile">
              <button
                className="button is-gold is-small is-rounded mr-2-tablet mb-2-mobile"
                onClick={handleSettings}
                title="Configuración"
              >
                <span className="icon">
                  <i className="fas fa-cog has-text-darkblue"></i>
                </span>
                <span className="is-hidden-tablet">Configuración</span>
              </button>
              <button
                className="button is-gold is-small is-rounded"
                onClick={handleLogout}
                title="Cerrar sesión"
              >
                <span className="icon">
                  <i className="fas fa-sign-out-alt has-text-darkblue"></i>
                </span>
                <span className="is-hidden-tablet">Cerrar sesión</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
